import moment from "moment";
import { useEffect, useRef, useState } from "react";

import { FiChevronDown } from "react-icons/fi";
import { primaryColor } from "../../../../utility/constants/colorManager";
import "./input.css";
import { validate } from "./validator";

const Input = ({
  styles,
  value,
  placeholder,
  onChange,
  validator,
  type,
  options,
  showBadge,
  showErrorMsg,
  isSpaceRequired = false,
  setNamesError,
  disabled = false,
  maxLength,
  onPressEnter,
  autoFocus,
  isPassword,
  isSvgIconRequired,
  imageUpload,
  isOtpField = false,
  dataTestId = "input",
  maxDate,
  filterFocus,
  dropdownImage = true,
  dropdownStyle,
  addMoney = false,
  onKeyPress,
  onMouseEnter,
  tabIndex,
  inputcomponentStyles,
  isRightIconRequired = false,
  rightIcon,
  isSelectObjectRequired = false,
  onChangeObject,
  className,
}) => {
  const [focus, setFocus] = useState(false);
  const wrapperRef = useRef(null);
  const [openDateRange, setOpenDateRange] = useState(false);

  const handleChangeRaw = (date) => {
    date.target.value = moment(date).format("DD/MM/YYYY");
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenDateRange(false);
      }
    }

    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  switch (type) {
    case "input":
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            border: filterFocus
              ? "0.1px solid white"
              : showErrorMsg
              ? "1px solid red"
              : "0.1px solid white",
            paddingLeft: 20,
            fontSize: 20,
            alignItems: "center",
            overflow: "hidden",
            ...styles,
          }}
          className="asterisk"
        >
          {validator === "amount1" && <p style={{ margin: 0 }}>₹</p>}
          {validator === "amount" && <p style={{ margin: 0 }}>₹</p>}
          <input
            autoComplete={"off"}
            tabIndex={tabIndex}
            id="inputelement"
            onKeyPress={onKeyPress}
            className={className ? className : "latoRegular"}
            data-testid={dataTestId}
            onClick={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            onKeyDown={(event) => {
              if (event.key === "Enter" && onPressEnter) {
                onPressEnter();
              }
            }}
            style={{
              border: "none",
              outline: "none",
              backgroundColor: "transparent",
              width: "80%",
              height: "100%",
              ...inputcomponentStyles,
            }}
            type={
              isPassword || isOtpField
                ? "password"
                : type === "email"
                ? "email"
                : "text"
            }
            disabled={disabled}
            maxLength={maxLength}
            value={value}
            placeholder={placeholder}
            onChange={(event) => {
              validate(
                validator,
                event.target.value,
                onChange,
                setNamesError,
                isSpaceRequired
              );
            }}
            autoCorrect="off"
            autoFocus={autoFocus}
          />
          {isRightIconRequired && rightIcon}
        </div>
      );

    case "login":
      return (
        <form style={{ width: "100%" }} autoComplete="off">
          <input
            autoComplete="new-password"
            id="inputelement"
            className="latoRegular"
            onKeyPress={onKeyPress}
            data-testid={dataTestId}
            onClick={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            onKeyDown={(event) => {
              if (event.key === "Enter" && onPressEnter) {
                onPressEnter();
              }
            }}
            style={{
              border: filterFocus
                ? "0.1px solid white"
                : focus
                ? "0.1px solid lightgrey"
                : showErrorMsg
                ? "1px solid red"
                : "0.1px solid white",
              padding: 0,
              paddingLeft: 20,
              fontSize: 20,
              minWidth: 280,
              maxWidth: 400,
              marginLeft: 10,
              marginRight: 10,
              ...styles,
              backgroundColor: "transparent",
            }}
            type={
              isPassword || isOtpField
                ? "password"
                : type === "email"
                ? "email"
                : "text"
            }
            disabled={disabled}
            maxLength={maxLength}
            value={value}
            placeholder={placeholder}
            onChange={(event) => {
              validate(
                validator,
                event.target.value,
                onChange,
                setNamesError,
                isSpaceRequired
              );
            }}
            autoCorrect="off"
            autoFocus={true}
          />
        </form>
      );
    case "select":
      return (
        <div
          style={{
            borderRadius: 7,
            display: dropdownImage && "flex",
            alignItems: dropdownImage && "center",
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            margin: 0,
            ...dropdownStyle,
          }}
        >
          <select
            className="select-dropdown"
            disabled={disabled}
            id="inputelement"
            value={value === "" ? "select" : value}
            placeholder={placeholder}
            onChange={(event) => {
              onChange(event.target.value);
              isSelectObjectRequired && onChangeObject(event.target);
            }}
            data-testid={dataTestId}
            style={{
              border: focus
                ? "1px solid black"
                : showBadge
                ? "1px solid #3F6AD8"
                : showErrorMsg
                ? "1px solid red"
                : "1px solid white",
              backgroundColor: "white",
              padding: 0,
              paddingLeft: 10,
              fontSize: 20,
              minWidth: 280,
              maxWidth: 400,
              opacity: disabled && 1,
              color: "grey",
              boxSizing: "border-box",
              ...styles,
            }}
            onMouseEnter={onMouseEnter}
          >
            {options &&
              options.map((option, index) => {
                return (
                  <option
                    key={index}
                    style={{}}
                    value={addMoney ? option.value : option.value}
                    className="select-option"
                  >
                    {option.label}
                  </option>
                );
              })}
          </select>
          {dropdownImage && (
            <FiChevronDown
              color={primaryColor}
              size={24}
              style={{
                position: "absolute",
                right: 10,
                top: "30%",
              }}
            />
          )}
        </div>
      );

    case "textarea":
      return (
        <div
          id="inputelement"
          style={{
            paddingTop: 5,
            display: "flex",
            flexDirection: "column",
            width: imageUpload ? "100%" : "auto",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              borderRadius: 5,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignitems: "center",
            }}
          >
            <textarea
              data-testid={dataTestId}
              className="title"
              style={{
                border: focus
                  ? "1px solid black"
                  : showBadge
                  ? "1px solid #3F6AD8"
                  : showErrorMsg
                  ? "1px solid red"
                  : "1px solid lightgrey",
                minWidth: "100%",
                ...styles,
                borderRadius: 5,
                fontSize: 12,
                color: "black",
                resize: "none",
                paddingLeft: isSvgIconRequired ? 50 : 10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              value={value}
              placeholder={placeholder}
              onChange={(event) => {
                const reg = /^[a-zA-Z0-9., ]+$/;
                const value = event.target.value;
                if (reg.test(value)) onChange(event.target.value);
                if (value === "") onChange("");
              }}
            />
          </div>
        </div>
      );

    default:
      return (
        <input
          id="inputelement"
          data-testid={dataTestId}
          style={{
            ...styles,
          }}
          onKeyPress={onKeyPress}
          value={value}
          placeholder={placeholder}
          onChange={(event) => {
            let val = event.target.value;
            if (validator === "") {
              onChange(val);
            }
          }}
        />
      );
  }
};

export default Input;
